import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { configureAuth, AuthProvider, UserProvider, ToastProvider } from '@tss/shared';
import { SubscriptionProvider } from './components/SubscriptionProvider';
import App from './App';
import './index.css';

// Initialize auth on load
configureAuth();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <UserProvider>
          <ToastProvider>
            <SubscriptionProvider>
              <App />
            </SubscriptionProvider>
          </ToastProvider>
        </UserProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
